const UPDATE_COMPONENT_STORE = 'update-component-store';
const REMOVE_COMPONENTS_STORE = 'remove-components-store';

export { UPDATE_COMPONENT_STORE, REMOVE_COMPONENTS_STORE };
